import { API, axios, SendRequest, toastr} from '@/imports-files/pages/candidates/add-candidate';


export class AddCandidate extends SendRequest
{
  async createCandidate(params)
  {
    try {
      const result = await axios.post( API.client.candidates.GET_CANDIDATE_LIST,
                                        params,
                                        this.setHeaderJSON(),
                                        this.setCrossDomainTrue(),
                                        this.setCredentialsJSON()
                                     );
      return result;
    } catch (error) {
      return error;
    }
  }

  async candidateToken(params, duplicateEmail)
  {
    try {
      const result = await axios.post( API.client.candidates.GET_CANDIDATE_TOKEN.replace('$client_candidate_id', duplicateEmail.client_candidate_id).replace('$job_application_id', duplicateEmail.job_application_id).replace('$job_id', duplicateEmail.job_id),
                                        params,
                                        this.setHeaderJSON(),
                                        this.setCrossDomainTrue(),
                                        this.setCredentialsJSON()
                                     );
      return result;
    } catch (error) {
      return error;
    }
  }
}
